import { Icon } from '@components';
import { Flex, theme, Typography } from '@styles';
import { ReactComponent as Decoration } from '@svgs/decoration_yellow.svg';
import { bool, shape, string } from 'prop-types';
import React from 'react';

import { StyledImage, StyledTypography } from '../../AboutUsPage.layoutProps';

const TextWithPic = ({
  description,
  founders,
  imageStyle,
  isTablet,
  left,
  src,
  style,
  title,
}) => (
  <Flex alignItems="center" position="relative" {...style}>
    {founders && (
      <Icon height="33px" left="0" position="absolute" SVG={Decoration} />
    )}
    {left && src && (
      <StyledImage
        alt="background"
        left="0"
        maxWidth="100%"
        position="relative"
        src={src}
        style={imageStyle}
      />
    )}
    <Flex
      justifyContent={left && src ? 'end' : 'start'}
      {...(isTablet && {
        marginBottom: '10% !important',
        marginLeft: '2.5% !important',
        marginRight: '2.5% !important',
        marginTop: `${founders && isTablet ? 0 : 10}% !important`,
      })}
    >
      <Flex
        flexDirection="column"
        {...(founders && isTablet && { marginTop: '15%' })}
      >
        <Typography
          color={theme.colors.white[100]}
          textAlign={left && src ? 'end' : 'start'}
          variant={isTablet ? 'BN-bold-s80-lh84' : 'BN-bold-s123-lh104'}
        >
          {title}
        </Typography>
        <StyledTypography
          color={theme.colors.white[100]}
          fontSize={founders ? '16px' : '26px'}
          founders={founders}
          mt={24}
          opacity={founders ? 0.6 : 1}
          textAlign={left && src ? 'end' : 'start'}
        >
          {description}
        </StyledTypography>
      </Flex>
    </Flex>
    {!left && src && (
      <StyledImage
        alt="background"
        founders={founders}
        maxWidth="100%"
        position="relative"
        right="0"
        src={src}
        style={imageStyle}
      />
    )}
  </Flex>
);

TextWithPic.propTypes = {
  description: string.isRequired,
  founders: bool,
  imageStyle: shape,
  isTablet: bool,
  left: bool,
  src: string,
  style: shape,
  title: string.isRequired,
};

TextWithPic.defaultProps = {
  founders: false,
  imageStyle: {},
  isTablet: false,
  left: false,
  src: null,
  style: {},
};
export default TextWithPic;
